import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import {SaleorderprocessType} from './sale-order-process-type.entity'
import {SaleorderprocessTypeDTO} from './dto/sale-order-process-type.dto';
import {SaleorderprocessTypeAdapter} from './dto/sale-order-process-type.adapter'
import {SaleOrderProcessResponseModel,AllSaleOrderProcessResponseModel} from '@gtpl/shared-models/masters';
import {SaleOrderProcessTypeRequest} from './dto/sale-order-process-type.request';

import { ErrorResponse } from '@gtpl/shared-models/common-models';


@Injectable()
export class SaleOrderProcessTypeService {
    constructor(
        @InjectRepository(SaleorderprocessType)
        private saleorderprocessTypeRepository: Repository<SaleorderprocessType>,
        private saleorderprocessTypeAdapter: SaleorderprocessTypeAdapter,){}

        async getSaleorderProcessTypeWithoutRelations( saleorderprocessTypeId :number): Promise<SaleorderprocessType>{
            const SaleorderprocessTypeResponse = await this.saleorderprocessTypeRepository .findOne({
              where: {saleorderprocessTypeId: Raw(alias => `sale_order_process_type_id = '${saleorderprocessTypeId}'`)},
            });
            if(SaleorderprocessTypeResponse){
              return SaleorderprocessTypeResponse;
            }
            else{
              return null;
            }
          }


          async createSaleorderprocessType(saleorderprocessTypeDTO: SaleorderprocessTypeDTO, isUpdate: boolean): Promise<SaleOrderProcessResponseModel>{
  
            // const response = new SaleorderTypeResponseModel();
            // const response = new AllGradesResponseModel(true,1,'Grades retrieved successfully',gradesDtos);
    
            try{
            const saleorderprocessTypeDtos: SaleorderprocessTypeDTO[] = [];
    
              if(!isUpdate){
                const SaleorderprocessTypeEntity = await this.getSaleorderProcessTypeWithoutRelations(saleorderprocessTypeDTO.saleorderprocessTypeId);
                if (SaleorderprocessTypeEntity){
                  throw new ErrorResponse(11104, 'Sale Order Process Type already exists'); 
                }
              }
              const convertedSaleorderprocessTypeEntity: SaleorderprocessType = this.saleorderprocessTypeAdapter.convertDtoToEntity(saleorderprocessTypeDTO,isUpdate);
    
              console.log(convertedSaleorderprocessTypeEntity);
            const savedSaleorderprocessTypeEntity: SaleorderprocessType = await this.saleorderprocessTypeRepository.save(convertedSaleorderprocessTypeEntity);
            const savedSaleorderprocessTypeDto: SaleorderprocessTypeDTO = this.saleorderprocessTypeAdapter.convertEntityToDto(savedSaleorderprocessTypeEntity);
            saleorderprocessTypeDtos.push(savedSaleorderprocessTypeDto)
              console.log(savedSaleorderprocessTypeDto);
            if (savedSaleorderprocessTypeDto) {
              //generating resposnse
              const response = new SaleOrderProcessResponseModel(true,1,'Sale order Process type retrieved successfully',saleorderprocessTypeDtos);
              return response;
            } else {
              //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
              throw new ErrorResponse(11106,'Sale Order Process type saved but issue while transforming into DTO');
            }
            
          } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            throw error;
          }
        }

        async getAllSaleorderprocessType(): Promise<AllSaleOrderProcessResponseModel> {
          // const page: number = 1;
          // const response = new AllSaleorderTypeResponseModel();
          try {
            const saleorderprocessTypeDTO: SaleorderprocessTypeDTO[] = [];
            //retrieves all companies
            const SaleorderprocessTypeEntity: SaleorderprocessType[] = await this.saleorderprocessTypeRepository.find({order :{'saleorderprocessTypeId':'ASC'}});
            //console.log(statesEntities);
            if (SaleorderprocessTypeEntity) {
              // converts the data fetched from the database which of type companies array to type StateDto array.
              SaleorderprocessTypeEntity.forEach(SaleorderprocessTypeEntity => {
                const convertedSaleorderprocessTypeDto: SaleorderprocessTypeDTO = this.saleorderprocessTypeAdapter.convertEntityToDto(
                    SaleorderprocessTypeEntity
                );
                saleorderprocessTypeDTO.push(convertedSaleorderprocessTypeDto);
              });
      
              //generated response
              const response = new AllSaleOrderProcessResponseModel(true,1,'Sale Order Process types retrieved successfully',saleorderprocessTypeDTO);
              return response;
            } else {
              throw new ErrorResponse(99998, 'Data not found');
            }
            // return response;
          } catch (err) {
            throw err;
          }
        }

        async getSaleOrderProcessTypeById(saleorderprocessTypeId: number): Promise<SaleorderprocessType> {
          const Response = await this.saleorderprocessTypeRepository.findOne({
          where: {saleorderprocessTypeId: saleorderprocessTypeId},
          });
          if (Response) {
          return Response;
          } else {
          return null;
          }
      }

      async activateOrDeactivateSaleOrderProcessType(saleordeprocessReq: SaleOrderProcessTypeRequest): Promise<SaleOrderProcessResponseModel> {
        try {
            const saleorderExists = await this.getSaleOrderProcessTypeById(saleordeprocessReq.saleorderprocessTypeId);
            if (saleorderExists) {
                if (saleordeprocessReq.versionFlag !== saleordeprocessReq.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Sale order information.Refresh and try again');
                } else {
                    
                        const saleorderStatus =  await this.saleorderprocessTypeRepository.update(
                            { saleorderprocessTypeId: saleordeprocessReq.saleorderprocessTypeId },
                            { isActive:saleordeprocessReq.isActive,updatedUser: saleordeprocessReq.updatedUser });
                       
                        if (saleorderExists.isActive) {
                            if (saleorderStatus.affected) {
                                const saleorderResponse: SaleOrderProcessResponseModel = new SaleOrderProcessResponseModel(true, 10115, 'Sale order is de-activated successfully');
                                return saleorderResponse;
                            } else {
                                throw new ErrorResponse(10111, 'sale order is already deactivated');
                            }
                        } else {
                            if (saleorderStatus.affected) {
                                const saleorderResponse: SaleOrderProcessResponseModel = new SaleOrderProcessResponseModel(true, 10114, 'Sale order is activated successfully');
                                return saleorderResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Sale order is already activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }


}


